import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { tap, filter, take, catchError, withLatestFrom, map } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromRoot from '../../store';
import { Observable, of, merge } from 'rxjs';
import { SetTheme } from '../../store';

@Injectable({ providedIn: 'root' })
export class DiseaseProfileGuard {
  private store = inject<Store<fromStore.DiseaseProfileState>>(Store);
  private actions$ = inject(Actions);
  private router = inject(Router);


  canActivate(): Observable<boolean | UrlTree> {
    return this.checkStore().pipe(catchError(() => of(this.router.parseUrl('/404'))));
  }

  checkStore(): Observable<boolean | UrlTree> {
    const loaded$ = this.store.select(fromStore.getSelectedDiseaseProfileLoaded).pipe(
      withLatestFrom(this.store.select(fromRoot.getRouterState), this.store.select(fromStore.getSelectedDiseaseProfile)),
      tap(([loaded, router, profile]) => {
        if (!loaded) {
          this.store.dispatch(
            fromStore.LoadDiseaseProfile({ id: router.state.params?.['diseaseProfileId'] || router.state.data?.['diseaseProfileId'] })
          );
        } else {
          const theme = profile?.category?.cssClass;
          this.store.dispatch(SetTheme({ theme: theme || 'standard' }));
        }
      }),
      map(([loaded]) => loaded),
      filter(loaded => !!loaded),
      map(() => true as boolean | UrlTree)
    );

    const failed$ = this.actions$.pipe(
      ofType(fromStore.LoadDiseaseProfileFail),
      map(() => this.router.parseUrl('/404'))
    );

    return merge(loaded$, failed$).pipe(take(1));
  }
}
